module.exports = __webpack_public_path__ + "img/image 21.7ca99fe8.png";